import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  Button,
  Typography,
  Grid,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { deleteVehicleSign, getVehicleSignsByUser } from "../../../actions/vehicleAction";
import WarningIcon from "@material-ui/icons/Warning";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 400,
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  btn: {
    marginTop: 30,
    marginBottom: 30,
  },
  warningIcon: {
    fontSize: 60,
    color: theme.palette.warning.main,
    marginBottom: 10,
  },
  title: {
    textAlign: "center",
  },
}));

const DeleteVehicleSignModal = ({ openDelete, handleCloseDelete, id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [feed, setFeed] = useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { loading, error } = useSelector((state) => state.vehicle);

  useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  const handleDelete = () => {
    dispatch(deleteVehicleSign(id));
    setTimeout(() => {
      handleCloseDelete();
      dispatch(getVehicleSignsByUser());
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: "Vehicle sign record deleted successfully.",
        success: true,
      }));
    }, 1500);
  };

  return (
    <Dialog
      open={openDelete}
      onClose={handleCloseDelete}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
    >
      <DialogTitle id="form-dialog-title" className={classes.title}>
        Delete Vehicle Sign Record
      </DialogTitle>
      <DialogContent>
        <div className={classes.root}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item>
              <WarningIcon className={classes.warningIcon} />
            </Grid>
            <Grid item>
              <Typography variant="body1" align="center">
                Are you sure you want to delete this vehicle sign record?
              </Typography>
            </Grid>
            <Grid item container spacing={2} justifyContent="center">
              <Grid item>
                <Button
                  color="default"
                  variant="outlined"
                  onClick={handleCloseDelete}
                  disabled={loading}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={handleDelete}
                  disabled={loading}
                >
                  {loading ? "Deleting..." : "Delete"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteVehicleSignModal;
